import React,{useState,useEffect} from 'react';
import CareerInfo from '../CareerInfo/CareerInfo';
import CareerSlider from '../CareerSlider.js/CareerSlider';
import './careerSection.css'
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
const CareerSection = () => {
  
  const [careerSlider,setCareerSlider] = useState(null);
  const [careerContent,setCareerContent] = useState(null);

  useEffect(() => {
      client
          .query({
              query: queries.career,
          })
          .then((response) => {
              const partnersContent = response.data.allCareers.edges[0].node;
              setCareerContent(partnersContent);
              setCareerSlider(partnersContent.career_slider);

          })
          .catch((error) => {
              console.error(error);
          });
  });


  return (
    <section style={{ backgroundImage: `url(${careerContent?.career_bg?.url})` }} className='career-container pattern'>
      <div id="career-stepper" className="container stepper">
     <CareerInfo careerContent={careerContent}></CareerInfo>
     {careerSlider != null ? <CareerSlider careerSlider={careerSlider}></CareerSlider> : null }
      </div>
    </section>
  );
};

export default CareerSection;